import React, { useState, createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
//Contexts
import { ResponsiveContext } from '~/contexts/ResponsiveContext';

export const SidebarContext = createContext();

const SidebarContextProvider = ({ children }) => {
  const { isMobile } = useContext(ResponsiveContext);
  let location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileCollapsed, setMobileCollapsed] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setMobileCollapsed(false);
    }
  }, [location, isMobile]);

  function ToggleCollapsed() {
    if (isMobile) {
      setMobileCollapsed(!mobileCollapsed);
    } else {
      setCollapsed(!collapsed);
    }
  }

  return (
    <SidebarContext.Provider
      value={{ collapsed, mobileCollapsed, ToggleCollapsed }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarContextProvider;
